(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('PerformancesController', PerformancesController);

    PerformancesController.$inject = ['$scope', 'Principal', '$sce', '$window'];

    function PerformancesController($scope, Principal, $sce, $window) {
        var vm = this;
        // vm.domain = domain;
        vm.grafanaUrl = "";
        vm.selectOne = selectOne;

        if (Principal.isAuthenticated()) {
            // selectOne(vm.domain);
        }

        function selectOne(domain) {
            var fleets = domain.fleets.map(function (f) {
                return f.id;
            });
            vm.grafanaUrl = domain.url.replace("-domainId-", domain.id).replace("-fleetsArray-", fleets.join("&var-fleets="));
            resizeFrame();
            angular.element($window).bind('resize', resizeFrame);
        }

        function resizeFrame() {
            var offsetY = 110;
            var pageHeight = $window.innerHeight;
            pageHeight = pageHeight > 600 ? pageHeight - offsetY : 600;
            var sizeX = Math.round((pageHeight / 100));
            vm.frameHeight = pageHeight; //(pageHeight - (pageHeight % 100));
            //var grafanaUrl = "http://192.169.0.1:3000/dashboard/db/jot_" + fleetId + "_" + objTypeId + "?var-object=" + objCode + "&kiosk"; //&panelId=3&fullscreen"
            vm.grafanaTrusted = $sce.trustAsResourceUrl(vm.grafanaUrl);
            if (!$scope.$$phase)
                $scope.$apply();
        }
    }
})();
